import React from 'react'
import { useModal } from 'webapp/components/common/GlobalModal'
import { useToast } from '@core/toast'
import { localizedStrings } from '@core/strings'
import { useGetProfile } from '@core/react-query/features/profile'
import { useSignOffPermit } from '@core/react-query/features/permits/permit'
import ConfirmModal from '@common/modal/ConfirmModal'
import { SignatureEdit } from '@common/Signature'
import { CircularProgress } from '@common/material'
import { ITemplateQuestionGroup } from '@core/entities/template/TemplateQuestionGroup'
import { Text } from '@common/fundamentals'

interface ComponentType {
  permitId: number
  templateId: number
  disclaimerText?: string
  postPermitChecksAnswersWrapper?: {
    trackingId: string
    answers: ITemplateQuestionGroup[]
    wrapperSessionTracking: {
      startTime: string
      endTime: string
    }
  }

  //deprecated fields - needed for legacy support
  postPermitChecksBody?: ITemplateQuestionGroup[]
}

export const PostPermitChecksSubmitModal: React.FC<ComponentType> = ({
  permitId,
  templateId,
  postPermitChecksBody,
  disclaimerText = localizedStrings.completePostPermitChecks,
  postPermitChecksAnswersWrapper,
}) => {
  const toast = useToast()
  const { hideModal } = useModal()
  const signOffPermit = useSignOffPermit()
  const { data: profile } = useGetProfile()

  return (
    <ConfirmModal
      title={localizedStrings.postPermitChecksDisclaimerTitle}
      confirmText={localizedStrings.submit}
      disabledConfirm={signOffPermit.isLoading}
      icon={
        signOffPermit.isLoading ? (
          <CircularProgress size={20} color='inherit' />
        ) : undefined
      }
      onConfirm={() => {
        signOffPermit.mutate(
          {
            permitId,
            templateId,
            postPermitChecksBody,
            postPermitChecksAnswersWrapper,
          },
          {
            onSuccess: () => hideModal(),
            onError: (e) => toast.error(e.message),
          },
        )
      }}
    >
      <Text dangerouslySetInnerHTML={{ __html: disclaimerText }} />
      <SignatureEdit readonly value={profile?.signatureUrl} />
    </ConfirmModal>
  )
}
